import { render, staticRenderFns } from "./juniorCollege.vue?vue&type=template&id=7d13d2f5&scoped=true&"
import script from "./juniorCollege.vue?vue&type=script&lang=js&"
export * from "./juniorCollege.vue?vue&type=script&lang=js&"
import style0 from "./juniorCollege.vue?vue&type=style&index=0&id=7d13d2f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d13d2f5",
  null
  
)

export default component.exports